
export const SETTINGS_TEXT = 'Settings';
export const ACC_DETAILS = 'Account Details';
export const ACC_DETAILS_LABEL = 'View your username or edit your password here.';
export const RESET_LABEL = 'Reset password';
export const LOADING_TEXT = 'Loading';
export const NEXT_TEXT = 'Next';
export const RESET_TEXT = 'Reset Password';
export const REST_FIRST_TEXT = 'To reset your password for this account, enter your account username.';
export const REST_SECOND_TEXT = 'Once the you password is changed, system will log you out'
export const CHOOSE_PASSWORD_TEXT = 'Choose a New Password';
export const CHOOSE_PASSWORD_DESCRIBE = 'Please enter your old password and choose a new passowrd.';
export const RESEND_TEXT = 'Resend Code';
export const PLEASE_WAIT = 'Please wait.. '
export const CANCEL_TEXT = 'Cancel';
export const OLD_PASSWORD_ERROR = 'Please enter a valid Old Password';
export const PASSWORD_SP_ERROR = 'Please use only allowed special characters and no repeated words';
export const PASSWORD_ERROR = 'Password must contain a minimum 14 characters and maximum 20 characters and a special character and a number.';
export const PASSWORD_NO_MATCH = 'Passwords do not match.';
export const OLD_PASSWORD_SAME = 'New Password and Old password cannot be same';
export const OTP_ERROR = 'Incorrect OTP.';
export const PASSWORD_MIN = 'Minimum 14 characters; Maximum 20 characters';
export const PASSWORD_CHAR = 'Minimum 1 uppercase[A-Z], 1 lower case [a-z] and  1 special character (!, #, @, %, *, :, _, ^ or -)';
export const PASSWORD_NUMBER_REQ = 'Minimum of 1 numeric character [0-9]'
export const PASSWORD_REP = 'No repeated words, characters, or numbers';
export const PASSWORD_HINT = 'Enter a password';
export const CONFIRM_PASSWORD_HINT = 'Enter confirm password';
export const PASSWORD_MSG = 'Your password must be different than your previous password and contain:';
export const PASSWORD_INDI_MSG = 'A temporary password will be configured and sent to the email on file.';
export const PASSWORD_TEXT = 'Password';
export const IACM_TEXT = 'ItsaCheckmate';
export const OTTER_TEXT = 'Otter';
export const USERNAME_HINT = 'Please enter a valid username';
export const EMAIL_HINT = 'Please enter a valid email';
export const EMAIL_HINT_711 = 'Please enter a valid 7-11 email';
